module.exports = __webpack_public_path__ + "static/media/burger.d74f4d93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/BurgerMenu/burger.svg
// module id = 242
// module chunks = 0